export default __webpack_public_path__ + "static/media/archi_view1.c6c8f665.webp";